<template>
  <div class="modal"
       @click="cancelChosenFile"
       @keydown.esc="cancelChosenFile"
       id="modal-feedback-subtest-attempt"
       tabindex="-1"
       role="dialog">
    <div class="modal-dialog">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title">
            {{ translate('modals.feedback.title') }}
          </h5>
        </div>

        <div class="modal-body">
          <div class="alert alert-warning">
            <i class="fa fa-warning"></i> {{ translate('modals.feedback.warning') }}
          </div>

          <form role="form" enctype="multipart/form-data">
            <div class="form-group row">
              <label class="col-md-4 col-form-label text-md-right" for="notes">
                {{ translate('modals.feedback.form.notes') }}
              </label>

              <div class="col-md-6">
                  <textarea id="notes"
                            class="form-control"
                            name="notes"
                            v-model="feedbackSubtestAttemptForm.notes"
                            :class="{'is-invalid': feedbackSubtestAttemptForm.errors.has('notes')}">
                  </textarea>
                  <span class="invalid-feedback"
                        v-if="feedbackSubtestAttemptForm.errors.has('notes')">
                      <strong>{{ feedbackSubtestAttemptForm.errors.get('notes') }}</strong>
                  </span>
              </div>
            </div>
            <div class="form-group row">
              <label class="col-md-4 col-form-label text-md-right" for="customFile">
                {{ translate('modals.feedback.form.file') }}
              </label>
              <div class="col-md-6">
                <div class="custom-file">
                  <input type="file"
                         ref="file"
                         name="file"
                         accept="application/pdf"
                         class="custom-file-input"
                         id="customFile"
                         @change="onAddFile"
                         :class="{'is-invalid': feedbackSubtestAttemptForm.errors.has('file')}">
                  <span class="invalid-feedback"
                        v-if="feedbackSubtestAttemptForm.errors.has('file')">
                      <strong>{{ feedbackSubtestAttemptForm.errors.get('file') }}</strong>
                  </span>
                  <label class="custom-file-label" for="customFile" v-if="fileName">
                    {{ fileName }}
                  </label>
                  <label class="custom-file-label" for="customFile" v-else>Choose file</label>
                </div>
              </div>
            </div>
          </form>
        </div>

        <div class="modal-footer">
          <button type="button"
                  class="btn btn-default"
                  data-dismiss="modal"
                  @click="cancelChosenFile">
            {{ translate('modals.feedback.cancel') }}
          </button>
          <button type="button"
                  class="btn btn-success"
                  @click.prevent="uploadFileAndFeedbackSubtestAttempt"
                  :disabled="feedbackSubtestAttemptForm.busy || fileName === 'Choose file'">
            {{ translate('modals.feedback.' + (subtestAttempt.notes && subtestAttempt.notes !== '' ? 'update' : 'send')) }}
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: ['subtestAttempt'],

  /**
   * The component's data.
   */
  data () {
    return {
      feedbackSubtestAttemptForm: new AppForm({
        notes: null,
      }),

      fileName: 'Choose file',
    };
  },

  watch: {
    subtestAttempt: function (newSubtestAttempt, oldSubtestAttempt) {
      this.initData(newSubtestAttempt);
    }
  },

  mounted () {
    this.initData(this.subtestAttempt);
  },

  methods: {
    initData (subtestAttempt) {
      this.feedbackSubtestAttemptForm.notes = subtestAttempt.notes;
    },

    onAddFile (event) {
      this.fileName = event.target.files[0].name;
    },

    cancelChosenFile () {
      this.$refs.file.value = '';
      this.fileName = 'Choose file';
    },

    uploadFileAndFeedbackSubtestAttempt () {
      let self = this;
      this.feedbackSubtestAttemptForm.startProcessing();

      // We need to gather a fresh FormData instance with the document file appended to
      // the data so we can POST it up to the server.
      let form = new FormData();
      form.append('file', this.$refs.file.files[0]);
      form.append('subtest_attempt_id', this.subtestAttempt.id);

      axios.post('/files', form)
        .then((response) => {
          self.feedbackSubtestAttemptForm.type = self.editSubtestAttemptType;
          self.feedbackSubtestAttempt();

          self.$refs.file.value = '';
          self.fileName = 'Choose file';
        }, (error) => {
          self.feedbackSubtestAttemptForm.setErrors(error.response.data.errors);
        });
    },

    /**
     * Feedback the Subtest Attempt.
     */
    feedbackSubtestAttempt () {
      let self = this;

      App.put('/api/subtest-attempts/' + this.subtestAttempt.id + '/feedback', this.feedbackSubtestAttemptForm)
        .then(() => {
          self.feedbackSubtestAttemptForm.finishProcessing();
          $('#modal-feedback-subtest-attempt').modal('hide');

          self.$parent.$emit('getSubtestAttempt', self.subtestAttempt.id);
        });
    },
  }
};
</script>
